export const datetoStringWithoutZone = (date: Date) => {
  // converts a date to a iso-formatted string by ignoring the timezone and milliseconds
  return new Date(date.valueOf() - date.getTimezoneOffset() * 60000)
    .toISOString()
    .replace('.000Z', '');
};
